import { render, staticRenderFns } from "./identificacion-sustancias-ver.vue?vue&type=template&id=6f4041a2&scoped=true&"
import script from "./identificacion-sustancias-ver.vue?vue&type=script&lang=js&"
export * from "./identificacion-sustancias-ver.vue?vue&type=script&lang=js&"
import style0 from "./identificacion-sustancias-ver.vue?vue&type=style&index=0&id=6f4041a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4041a2",
  null
  
)

export default component.exports